export enum HttpResponseStatus {
  BAD_REQUEST = 400,
}
